import {
    BackButton,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDropDown,
    FormInput,
    FormRadio,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingAnimal = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_Animal.animal' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_Animal.animalDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormInput
                    label={<FormattedMessage id='Profile_Dwellings_Animal.number' />}
                    value={props.animal?.number}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}number`, value })}
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_Animal.type' />}
                    value={props.animal?.type}
                    references={props.reference.references?.AnimalType}
                    referencesEvent={() => props.reference.doGetReferences('AnimalType')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}type`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                {props.animal?.type && props.animal.type.code === 'Dog' && (
                    <FormDropDown
                        label={<FormattedMessage id='Profile_Dwellings_Animal.breed' />}
                        value={props.animal?.breed}
                        references={props.reference.references?.DogBreed}
                        referencesEvent={() => props.reference.doGetReferences('DogBreed')}
                        changeEvent={(value) =>
                            setAttributeEntity(`${props.dotProp}breed`, value, props.doReducePolicyElement)
                        }
                        allowEdit
                    />
                )}
                {props.animal?.type && props.animal.type.code === 'Dog' && (
                    <FormRadio
                        label={<FormattedMessage id='Profile_Dwellings_Animal.biteHistory' />}
                        value={props.animal && { code: convertFromBoolean(props.animal.biteHistory) }}
                        references={props.reference.references?.YesNo}
                        referencesEvent={() => props.reference.doGetReferences('YesNo')}
                        changeEvent={(value) =>
                            props.doReducePolicyElement({
                                code: `${props.dotProp}biteHistory`,
                                value: convertToBoolean(value.code),
                            })
                        }
                        allowEdit
                    />
                )}
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingAnimal;
